<section class="nebenantrag-detail-page--top-section">
    <div class="nebenantrag-detail-page--top-section--top-half">
        <h1>Nebenantrag für "{{ projectName | async }}"</h1>
    </div>

    <div class="nebenantrag-detail-page--top-section--bottom-half">
        <mat-card class="nebenantrag-detail-page--top-section--bottom-half__mat-card">
            <div class="nebenantrag-detail-page--top-section--bottom-half__art-card">
                <img
                    src="/assets/images/svgs/arrow-right-thin.svg"
                    class="nebenantrag-detail-page--top-section--bottom-half__art-card__arrow-svg"
                    alt="Pfeil rechts"
                />
                <p class="text-accordeon-card-title" style="font-size: 20; color: var(--color-accent-primary); padding-right: 2rem;">{{ displayedNebenantragsart.bezeichnung }}</p>
                <img
                    src="/assets/images/svgs/folder-open-outline.svg"
                    class="nebenantrag-detail-page--top-section--bottom-half__art-card__folder-svg"
                    alt="Ordner rechts"
                    style="padding-right: 1rem;"
                />
                <p class="text-plain" style="font-size: 16; color: var(--color-accent-primary);">Bisher gestellte Anträge: </p>
                <p class="text-plain" style="font-size: 16; color: var(--color-primary); font-weight: bold;">{{ displayedNebenantragsart.amount }}</p>
            </div>
        </mat-card>
        <app-button
            *ngIf="isNebenantragCreateable$ | async"
            buttonClass="nebenantrag-detail-page--top-section--top-half--button-width"
            [buttonLabel]="getNewAntragLabel(displayedNebenantragsart)"
            (clickEvent)="navigateToFormular()"
            [isButton]="true"></app-button>
    </div>
</section>
<section class="nebenantrag-detail-page--bottom-section">
    <app-card>
        <div class="nebenantrag-detail-page--bottom-section__card-content">
            <div class="nebenantrag-detail-page--bottom-section__card-content--top">
                <app-quick-filter
                    class="nebenantrag-detail-page--bottom-section__card-content--top__filter"
                    [quickFilterMenuItems]="quickFilterMenuItems">
                </app-quick-filter>
                <app-search
                    class="nebenantrag-detail-page--bottom-section__card-content--top__search"
                    (searchEvent)="searchHandler($event)">
                </app-search>
            </div>
            <app-data-table
                class="nebenantrag-detail-page--bottom-section__card-content--bottom"
                [tableConfig]="tableConfig"
                (sortEvent)="sortHandler($event)"
                (pageEvent)="pageHandler($event)">
            </app-data-table>
        </div>
    </app-card>
</section>
